import React from 'react'
import createReactClass from 'create-react-class'
import TranslationsFormPanel from './translations-form-panel'
import TranslationsResultPanel from './translations-result'

export default createReactClass({
  backToSearchPage () {
    this.props.history.push('/search')
  },
  render () {
    return (
      <div className='container'>
        <div>
          <button className='cs-secondary-button' onClick={this.backToSearchPage}>
            <span className='fa fa-caret-left'/>
            Back
          </button>
        </div>
        <div className="search-panel">
          <div className="csc-panel">
            <div className="panel-body">
              <h4 className="card-title">
                Monitoring Translations
              </h4>
              <TranslationsFormPanel {...this.props}/>
            </div>
          </div>
        </div>
        <div className="csc-panel">
          <div className="panel-body">
            <h4 className="card-title">Search Results
              {this.props.totalSize > 0
                ? <div className='count-box pull-right'>Total count:
                  <span className='value-color'>{this.props.totalSize}</span></div>
                : ''}
            </h4>
            <TranslationsResultPanel {...this.props}/>
          </div>
        </div>
      </div>
    )
  },
  componentDidMount () {
    this.props.getUserDetails(this.props.getUserAccessActions)
  },

})



// WEBPACK FOOTER //
// ./src/components/monitoring-translations/monitoring-translations-panel.js